export default __webpack_public_path__ + "static/media/Matsal6.abb62486.jpeg";